import React from "react"
import Layout from "../components/layout"
import Gallery from "../components/gallery"
import SEO from "../components/seo"
import Image from "../components/image"
import Graphic from '../images/beary-graphic.svg'

const IndexPage = () => (
    <Layout>
        <SEO title="Home" />
        <header className="padding-section hero-section">
            <div className="container hero-wrap">
                <h1 className="hero-heading">Happy 21st Birthday 🎉 🎂</h1>
                <div className="hero-img">
                    <img src={ Graphic } alt="Beary Graphic"/>
                </div>
            </div>
        </header>

        <section className="padding-section message-section">
            <div className="container">
                <div className="message-wrap">
                    <p className="mb-0">To the most adorable person, I have ever met, happy 21st birthday!! Even though you're getting old, I still love you very much 💗 I'm very excited to celebrate the Festivus of Roni which is my attempt to compete with your new Sausage and Mini Cooper. I hope you have the best day ever and that it is filled with hugs and squishes!</p>
                </div>
            </div>
        </section>

        <Gallery />

        <section className="padding-section mixtape-section">
            <div className="container mixtape-wrap">
                <h1 className="display-4 mb-4">Mixtape</h1>
                <iframe title="mixtape" src="https://open.spotify.com/embed/user/blode123/playlist/7L01qCkXtkBSuc3lyG3S3r" width="100%" height="300" frameborder="0" allowtransparency="true" allow="encrypted-media"></iframe>
            </div>
        </section>

        <section className="padding-section presents-section">
            <div className="container presents-wrap">
                <div className="row">
                    <div className="col-12">
                        <h3>01.</h3>
                        <h1 className="display-4 mb-4">Japanese snacks</h1>
                        <p className="h4">A care-package of lollies from Japan</p>
                    </div>
                </div>

                <div className="row">
                    <div className="col-12">
                        <h3>02.</h3>
                        <h1 className="display-4 mb-4">Drive-in movie</h1>
                        <p className="h4">Spider-Man: Far from Home</p>
                    </div>
                </div>

                <div className="row">
                    <div className="col-12">
                        <h3>03.</h3>
                        <h1 className="display-4 mb-4">Day spa</h1>
                        <p className="h4">Relaxing massage and facial at Endota Spa</p>
                    </div>
                </div>
            </div>
        </section>

        <footer className="p-3">
            <p className="text-center mb-0">Have a nice day eggo</p>
        </footer>
    </Layout>
)

export default IndexPage
